import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import logo from '../assets/logo.png';

export function CabecalhoInstitucional() {
  return (
    <Navbar expand="md" style={{ background: 'transparent' }} className="py-3">
      <Container style={{ maxWidth: '1140px' }}>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2">
          <img src={logo} alt="Lizzi Food" width={36} height={36} />
          <strong style={{ color: 'var(--cor-texto)', fontSize: '18px' }}>Lizzi Food</strong>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-institucional" />
        <Navbar.Collapse id="navbar-institucional" className="justify-content-end">
          <Nav className="align-items-md-center gap-2 py-2 py-md-0">
            <Nav.Link as={Link} to="/#recursos" style={{ color: 'var(--cor-texto)', fontWeight: 500 }}>
              Recursos
            </Nav.Link>
            <Nav.Link as={Link} to="/#precos" style={{ color: 'var(--cor-texto)', fontWeight: 500 }}>
              Preços
            </Nav.Link>
            <Link to="/login" className="btn btn-outline-primary fw-semibold">
              Entrar
            </Link>
            <Link
              to="/cadastro"
              className="btn fw-semibold text-white"
              style={{ background: 'var(--cor-gradiente)', border: 'none' }}
            >
              Criar conta grátis
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
